import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DraEmptyComponent} from './dra-empty.component';

@NgModule({
  declarations: [DraEmptyComponent],
  imports: [CommonModule],
  exports: [DraEmptyComponent],
})
export class DraEmptyModule {}
